export interface AboutData {
  title: string
  subtitle: string
  description: string
  paragraphs: string[]
  primaryButton: {
    text: string
    href: string
  }
  secondaryButton: {
    text: string
    href: string
  }
  achievements: {
    icon: string
    title: string
    description: string
  }[]
}

export const aboutData: AboutData = {
  title: "About",
  subtitle: "Me",
  description: "I'm a passionate Senior Software Engineer with 6+ years of experience in full-stack development, specializing in React, Next.js, Node.js, Python frameworks (Flask, Django), and cloud technologies—plus hands-on experience training and evaluating LLM-powered agents for real-world developer workflows.",
  paragraphs: [
    "My journey in software development has equipped me with expertise across the entire tech stack, from modern frontend frameworks like React and Next.js to backend technologies including Node.js, Express, Python frameworks (Flask, Django), and cloud infrastructure. I specialize in building scalable, performant applications that deliver exceptional user experiences.",
    "I've successfully developed and deployed numerous web applications, e-commerce platforms, and enterprise solutions. My experience includes working with modern development practices, CI/CD pipelines, cloud platforms like AWS and Azure, and infrastructure automation to ensure robust, secure, and maintainable systems. I also design high-fidelity demonstrations for LLM-powered Computer Use Agents, simulating multi-OS tasks and debugging workflows to improve agent reliability, safety, and technical correctness.",
    "When I'm not coding, you can find me exploring new technologies, contributing to open-source projects, or sharing knowledge through technical writing and mentoring. I'm passionate about staying current with industry trends and best practices to deliver cutting-edge solutions."
  ],
  primaryButton: {
    text: "Let's Connect",
    href: "#contact"
  },
  secondaryButton: {
    text: "View My Work",
    href: "#projects"
  },
  achievements: [
    {
      icon: "FaServer",
      title: "Full-Stack Expert",
      description: "Developed complete web applications using React, Next.js, Node.js, Python frameworks (Flask, Django), and modern frontend frameworks with responsive design and optimal performance."
    },
    {
      icon: "FaCloud",
      title: "Cloud & DevOps",
      description: "Implemented CI/CD pipelines, containerization with Docker, and cloud deployment strategies on AWS and Azure for scalable, reliable applications."
    },
    {
      icon: "FaShieldAlt",
      title: "Security Focused",
      description: "Built secure applications with authentication, authorization, data encryption, and compliance with industry security standards and best practices."
    },
    {
      icon: "FaRocket",
      title: "Performance Optimizer",
      description: "Optimized application performance through code refactoring, database optimization, caching strategies, and implementing modern web technologies."
    }
  ]
} 